import { COUPON_TYPES } from '../../../../services/exports/Constants';

const Coupons: Record<COUPON_TYPES, string> = {
  [COUPON_TYPES.PROMO_CODE]: 'Etukoodi {{code}} käytetty',
  [COUPON_TYPES.CASHBACK]: 'Kanta-asiakaspisteet käytetty',
  [COUPON_TYPES.REWARD]: 'Palkinto käytetty',
  [COUPON_TYPES.GIFT_CARD]: 'Lahjakortti käytetty',
};

export default Coupons;
